import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { type SxProps } from '@mui/material/styles';

import { useWaitlist } from 'reservations/waitlist/providers/WaitlistProvider';

type JoinWaitlistButtonVariant = 'outlined' | 'default';

type JoinWaitlistButtonProps = {
  showNumberOfPartiesAhead?: boolean;
  onClick: (..._args: unknown[]) => void;
  sxProps?: SxProps;
  variant?: JoinWaitlistButtonVariant;
};

function getFormattedPositionOnList(waitCount: number): string {
  if (waitCount === 1) {
    return '1 party on the list';
  }

  return `${waitCount} parties on the list`;
}

function JoinWaitlistPartiesOnListText() {
  const { waitCount } = useWaitlist();

  return (
    <Typography
      sx={theme => ({
        // @ts-ignore, https://github.com/mui/material-ui/issues/30678
        color: theme.palette.button?.font.main,
        lineHeight: 'initial',
        fontSize: '14px',
        fontWeight: 'light'
      })}
    >
      {getFormattedPositionOnList(waitCount)}
    </Typography>
  );
}

function JoinWaitlistButton({
  onClick,
  sxProps = {},
  showNumberOfPartiesAhead = false,
  variant = 'default'
}: JoinWaitlistButtonProps) {
  if (variant === 'outlined') {
    return (
      <Box>
        <Button onClick={onClick} sx={sxProps}>
          <Box>
            <Typography
              sx={theme => ({
                // @ts-ignore, https://github.com/mui/material-ui/issues/30678
                color: theme.palette.button?.font.main,
                fontWeight: 'bold',
                fontSize: '1.1rem',
                lineHeight: 'initial'
              })}
            >
              Join Waitlist
            </Typography>
            {showNumberOfPartiesAhead && <JoinWaitlistPartiesOnListText />}
          </Box>
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        rowGap: '10px'
      }}
    >
      <Button data-testid="join-waitlist-button" sx={sxProps} onClick={onClick}>
        Join Waitlist
      </Button>
      {showNumberOfPartiesAhead && <JoinWaitlistPartiesOnListText />}
    </Box>
  );
}

export default JoinWaitlistButton;
